import { useRef, useState } from "react";
import VisitClientSelect from "./visit-client-select";
import VisitClient from "./visit-client";
import VisitsClientAbons from "./visits-client-abons";
import { Button, Form, Input, message, Popconfirm } from "antd";
import { serverFetch } from "../../server";
import SaleAdd from "../sales/sale-add";
import { CloseOutlined } from "@ant-design/icons";
import { isMobile } from "../../extensions/design";

const VisitClientAdd = ({ onClose, defaultClientId }) => {
  const [clientId, setClientId] = useState(defaultClientId);
  const [item, setItem] = useState();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saleAdd, setSaleAdd] = useState(false);
  const clientAbonsRef = useRef();

  const onValuesChange = value => setItem({...item, ...value})

  const onSave = () => {
    setLoading(true);
    serverFetch("visit", { method: "POST", bodyData: item})
      .then(data => onClose(true, data.id))
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  } 

  const onSaleAddClose = ( refresh ) => {
    setSaleAdd(false);
    refresh && clientAbonsRef.current.getItems();
  }

  const onSaleActive = () => {
    setLoading(true);
    serverFetch("sale/SetActivated", {method: "POST", bodyData: {saleId: item?.saleId}})
      .then(() => {
        setLoading(false);
        clientAbonsRef.current.getItems();
        setItem({...item, status: 2})
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onSaleUnfreeze = () => {
    setLoading(true);
    serverFetch("sale/SetUnfrozen", {method: "POST", bodyData: {saleId: item?.saleId}})
      .then(() => {
        setLoading(false);
        clientAbonsRef.current.getItems();
        setItem({...item, status: 2})
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  console.log("item", item)

  const divButtons = isMobile ? <div className="visit-client-add-buttons record-form-item-with-margin-top-mobile">
    {loading ? null : <Button disabled={loading} onClick={() => setSaleAdd(true)}>Продать</Button>}
    {!item?.saleId || loading || (item?.status !== 1 && item?.status !== 0) ? null : <Button onClick={onSaleActive}>Активировать</Button>}
    {!item?.saleId || loading || item?.status !== 3 ? null : 
      <Popconfirm title="Подтверждение" description="Разморозить абонемент?" onConfirm={onSaleUnfreeze} placement="top" getPopupContainer={(trigger) => trigger.closest('.visit-client-add-buttons record-form-item-with-margin-top-mobile')} overlayClassName="centered-popconfirm">
        <Button>Разморозить</Button>
      </Popconfirm>}
    {!item?.saleId || loading || item?.status !== 2 ? null : <Button onClick={onSave}>Открыть визит</Button>}
  </div> : <>
    <Form.Item label=" ">
      <div className="main-content">
        <Button disabled={loading} onClick={() => setSaleAdd(true)}>Продать</Button>
        <Button disabled={!item?.saleId || loading || (item?.status !== 1 && item?.status !== 0)} onClick={onSaleActive}>Активировать</Button>
        <Popconfirm title="Подтверждение" description="Разморозить абонемент?" onConfirm={onSaleUnfreeze}>
          <Button disabled={!item?.saleId || loading || item?.status !== 3}>Разморозить</Button>
        </Popconfirm>
        <Button onClick={onSave} disabled={!item?.saleId || loading || item?.status !== 2}>Открыть визит</Button>
        <Button onClick={() => onClose(false)} disabled={!item?.saleId || loading}>Отмена</Button>
      </div>
    </Form.Item>
  </>

  return<div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className={!isMobile ? "sport-modal-content" : "sport-modal-content mobile-content" } style={isMobile ? {} : {width: 900}} onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Визит клиента</span>
          <CloseOutlined className="sport-section-title-close" onClick={onClose} style={{ zIndex: 9 }}   />
        </div>
    {!clientId && <VisitClientSelect onSelect={setClientId} onCancel={() => onClose(false)}/>}
    {clientId && <>
      <VisitClient id={clientId} onRefresh={() => clientAbonsRef.current.getItems()}/>
      <VisitsClientAbons clientId={clientId} onSelect={sale => setItem({...item, saleId: sale?.id, status: sale?.status })} saleId={item?.saleId} ref={clientAbonsRef}/>
      <Form layout={ isMobile? "inline" : "" } form={form} onValuesChange={onValuesChange} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} colon={false} disabled={!item?.saleId}>
        <Form.Item className={ isMobile ? "records-form-item-mobile" : ""} label="Ключ" name="keyName" wrapperCol={!isMobile ? {span: 3} : {}}>
          <Input className={ isMobile ? "records-form-item-mobile" : ""} />
        </Form.Item>
        <Form.Item className={ isMobile ? "record-form-item-with-margin-top-mobile" : ""} label="Коммент." name="comment" wrapperCol={!isMobile ? {span: 16} : {}}>
          <Input className={ isMobile ? "records-form-item-mobile" : ""}/>
        </Form.Item>
        {divButtons}
      </Form>
      {saleAdd && <SaleAdd onClose={onSaleAddClose} clientId={clientId} activeBtns={["Абонемент"]} />}
    </>}
  </div>
  </div>
  </div>
}

export default VisitClientAdd;